module.exports = __webpack_public_path__ + "static/media/FidWeb-Company-Presentation-2023.85a3d39f.pdf";